import styled from "styled-components";

const DINEOUT_HEADER_HEIGHT = "64px";

export const ScenesFullPaymentContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const ErrorContentWrapper = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: `calc(100vh - ${DINEOUT_HEADER_HEIGHT})`,
});
